<div class="container-fluid  pt-3">
  <div class="row" style="display: flex;align-items: center;">
    <div class="col-md-6 w-100 pr-0">
      <div class="d-flex justify-content-between ">
        <div class="header-infos">
          <p class="m-0 text-uppercase" style="font-size: 20px; color: #262756;font-weight: bold"> Rapports
          </p>
          <small class="text-uppercase" style="font-size:15px;color: #707070;">Rapport Favoris</small>
        </div>
        <div style="width: 47%">
        </div>
      </div>
    </div>
    <div class="col-md-5   w-100">
      <div class="row  px-3" style=" display: flex;
      justify-content: flex-end;">
      </div>
    </div>
  </div>
  <div class="row pt-2">
    <div class="col-sm-12 col-xs-12 col-xl-3 col-lg-3 col-md-12 w-100 pl-0">
      <div class="mb-2">
        <div class="export-icons d-flex mb-2">
          <div placement="bottom" class="favoris">
            <a
              [routerLink]="['/user/report']"
              routerLinkActive="router-link-active"
            >
              <img
                ngbTooltip="Générer rapport"
                src="assets/icons/GenerateReport.svg"
              />
            </a>
          </div>
          <div placement="bottom" class="favoris">
            <a [routerLink]="['/user/reportfavorite']" routerLinkActive="router-link-active">
              <img ngbTooltip="Favoris" src="assets/icons/favoris.svg" />
            </a>
          </div>
          <div placement="bottom" class="planification">
            <a [routerLink]="['/user/plannification']" routerLinkActive="router-link-active">
              <img ngbTooltip="Plannifier un rapport" src="assets/icons/planification.svg" />
            </a>
          </div>
          <div placement="bottom" class="historique">
            <a [routerLink]="['/user/reportHistory']" routerLinkActive="router-link-active">
              <img ngbTooltip="Historique" src="assets/icons/historique.svg" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr style="border: 1px solid #e8e4e4;margin-top: 0%;">
  <div class="row">
    <div class="col-lg-12 col-xl-12 col-md-12 w-100 pl-0">
      <div class="row">
        <div class="col-md-8">
        </div>
        <div class="col-md-4 mb-2">
          <div class="row">

            <div class="col-md-6" style="height: 70px; display: flex;
            justify-content: center; align-items: center;">
              <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 5px;">
                <mat-label>Chercher dans les favoris</mat-label>
                <input matInput (keyup)="applyFilter($event)"
                #input placeholder="Chercher"   [(ngModel)]="searchbyname"
                value="{{ searchbyname  }}"  >
                <mat-icon matSuffix placement="left" ngbTooltip="Chercher un ou plusieurs rapports">search</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <div
              *ngIf="ItemSelected.length >1"
                (click)="supprimerRapport_RightClick('moreThanOne',null)"
                class="mat-form-field"
                placement="left"
                ngbTooltip="Supprimer plusieurs plannification des rapports"
                style="
                  height: 63px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 63px;
                "
              >
                <mat-icon style="font-size: 25px; padding: 0 !important"
                  >delete_forever</mat-icon
                >
              </div>

            </div>

          </div>
        </div>
      </div>
      <div class="example-container  mat-elevation-z8">
        <table mat-table #exportDirective="matTableExporter" matTableExporter [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let row" (click)="selection.toggle(element)">
              <mat-checkbox disabled
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
              [aria-label]="checkboxLabel(row)"
              >
            </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom </th>
            <td mat-cell *matCellDef="let element" (click)="selection.toggle(element)"
              (click)="getItemDetails2(element)"> {{element.name}} </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Type de rapport </th>
            <td mat-cell *matCellDef="let element" (click)="selection.toggle(element)"
                (click)="getItemDetails2(element)">
              <div *ngIf="(element.type == 1)"> Rapport de flotte </div>
              <div *ngIf="(element.type == 2)"> Rapport détaillé </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de Création </th>
            <td mat-cell *matCellDef="let element" (click)="selection.toggle(element)"
                (click)="getItemDetails2(element)"> {{element.created_at }}
            </td>
          </ng-container>
          <ng-container matColumnDef="typeExport">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 5% !important;"> Type d'export
            </th>
            <td mat-cell *matCellDef="let element" [style.color]="element.typeExport"
                (click)="getItemDetails2(element)" >
              <img placement="right" ngbTooltip="Type PDF" style="width: 30px; height: 30px; cursor: default;position: relative;
              left: 30%;" src="assets/newImages/pdf-svg.svg" />
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
            <td mat-cell *matCellDef="let element"(click)="selection.toggle(element)"  >
              <a [ngStyle]="{'pointer-events': ItemSelected.length >1 ? 'none' : 'all'
               , 'opacity':ItemSelected.length >1 ?'0.5' : '1'}">
                <img
                  src="assets/icons/icon-modifier.svg" (click)="modifierRapport(element)" placement="top"
                  ngbTooltip="Modifier {{element.name}}" />
              </a>
                <a
                [ngStyle]="{'pointer-events': ItemSelected.length >1 ? 'none' : 'all'
               , 'opacity':ItemSelected.length >1 ?'0.5' : '1'}"
                >

                 <img placement="left"
                 ngbTooltip="Supprimer favoris "
                 src="assets/icons/icon-delete.svg"
                 (click)="supprimerRapport_RightClick('oneItem',element.id)"/></a>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="12">
              Aucune donnée correspondante à votre recherche
            </td>
          </tr>
        </table>
        <mat-paginator #paginator [pageSize]="15"
        [length]="dataSource?.data.length"
         [pageSizeOptions]="[15, 30, 100]"
         (page)="pageChanged($event)"
          [showFirstLastButtons]="true">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
